<script>
  import { format } from 'svelte-i18n';
  import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let props = {};
  export let row = {};
</script>

<ButtonDropdown>
  <DropdownToggle color="none" tag="span">
    <Icon name="more-vertical" class="action-icon" />
  </DropdownToggle>
  <DropdownMenu>
    <DropdownItem on:click={() => props.onPush(row)}>
      {$format('label.REPEAT_PUSH')}
    </DropdownItem>
  </DropdownMenu>
</ButtonDropdown>

<style lang="scss" src="./actions-cell.scss"></style>
